module.exports = __webpack_public_path__ + "img/kaist_main1.f6d41532.jpg";